import React, { useEffect, useState } from "react";
import RadioCard from "./RadioCard";
import { RadioWrapper, RadioListWrapper } from "./styles";

const RadioCardList = ({ list, selectedIndices, onChange }) => {
  const [selectedCards, setSelectedCards] = useState(new Set()); // using set data type to handle duplicacy
  useEffect(() => {
    // adding 
    if(selectedIndices && selectedIndices.length) {
      selectedIndices.forEach(element => addToSelected(element))
    }
  }, []);

  useEffect(() => {
    onChange(selectedCards);
  }, [selectedCards]);

  const isSelected = (index) => {
    return selectedCards.has(index);
  };

  const addToSelected = (index) => {
    if (isSelected(index)) {
      deleteFromSelectedCards(setSelectedCards, index);
    } else {
      addToSelectedCards(setSelectedCards, index);
    }
  };

  const addToSelectedCards = (setSelectedCards, index) => {
    setSelectedCards((prev) => new Set(prev).add(index));
  };

  const deleteFromSelectedCards = (setSelectedCards, index) => {
    setSelectedCards((prev) => {
      const newSet = new Set(prev);
      newSet.delete(index);
      return newSet;
    });
  };

  return (
    <RadioListWrapper>
      {list.map((text, index) => (
        <RadioWrapper key={index}>
          <RadioCard
            text={text}
            isSelected={isSelected(index)}
            onSelect={() => addToSelected(index)}
          />
        </RadioWrapper>
      ))}
    </RadioListWrapper>
  );
};

export default RadioCardList;
